import styled from 'styled-components';

export const Container = styled.div``;

export const ActionHeader = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  gap: 16px;

  & > div {
    margin-bottom: 0;
  }
  button {
    width: fit-content;
    background: #2d6cdf;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    &:hover {
      background: #2d6cdf;
      color: #ffffff;
    }
  }
  .status-label {
    min-height: auto;
    label {
      display: none;
    }
  }
`;
export const CardsGrid = styled.div`
  display: ${(props) => (props.$isEmpty ? 'block' : 'grid')};
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
`;

export const CardContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 25px 15px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
export const CardHeaderTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin: 0;
  cursor: pointer;
  transition: color 0.2s ease;
  word-break: break-all;
  overflow-wrap: break-word;
  width: 100%;
  padding-right: 20px;

  &:hover {
    color: #2d6cdf;
  }
`;
export const Badge = styled.span`
  background-color: ${({ $active }) =>
    $active ? 'rgba(21, 199, 167, 0.1)' : 'rgb(212, 216, 221)'};

  color: ${({ $active }) => ($active ? '#15c7a7' : '#fff')};
  padding: 3px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
`;

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: ${(props) => (props.$right ? 'right' : 'left')};
`;

export const StatLabel = styled.span`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 8px;
`;

export const StatValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #2d6cdf;
`;

export const DateValue = styled(StatValue)`
  font-size: 16px;
  color: #212529;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
  gap: 10px;
  font-size: 14px;
  color: #000000;

  & > :last-child {
    margin-left: auto;
  }
`;

export const EditBtn = styled.img`
  width: 16px;
  height: 16px;

  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  filter: ${(props) => (props.$disabled ? 'grayscale(100%)' : 'none')};

  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  transition: all 0.2s ease;
`;
export const EffectiveDateSection = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
  margin-top: 8px;

  ${StatLabel} {
    margin-bottom: 0;
  }
`;
export const LoadContainer = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  min-height: 500px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyWrapper = styled.div`
  height: 100%;
  padding: 145px;
`;
export const LoadingIcon = styled.img`
  animation: rotate 1s linear infinite;
  width: 100px;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
